import { render, staticRenderFns } from "./ProductRegion.vue?vue&type=template&id=7aabdbff&scoped=true"
import script from "./ProductRegion.vue?vue&type=script&lang=js"
export * from "./ProductRegion.vue?vue&type=script&lang=js"
import style0 from "./ProductRegion.vue?vue&type=style&index=0&id=7aabdbff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aabdbff",
  null
  
)

export default component.exports